import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    min = _ref2[0],
    max = _ref2[1];
  return Math.min(max, Math.max(min, value));
}
export { $ae6933e535247d3d$export$7d15b64cf5a3a4c4 as clamp };